"use client";

import useMediaQuery from "@mui/material/useMediaQuery";
import throttle from "lodash.throttle";
import React from "react";
import { useHydrated } from "src/hooks/use-hydrated";
import Topbar from "src/lib/components/header/default/top-bar";
import Sticky from "src/lib/components/header/default/Sticky";
import Header from "src/lib/components/header/default/header";

import MobileNavigationBar from "src/lib/components/header/default/mobile-navigation-bar";
import SearchInput from "./default/search-input";

export interface VariantProps {
  logoUrl?: string;
  name: string;
  nav: Array<{ label: string; url: string }>;
  notification: { type: "error"; label: string; text: string };
  /** @default "/product" */
  productUrlPrefix?: string;
  /** @default "/checkout" */
  checkoutUrl?: string;
  /** @default "/cart" */
  cartUrl?: string;
  socialItems?: Array<{
    type: "facebook" | "twitter" | "youtube" | "pinterest" | "instagram";
    url: string;
  }>;
}

const HeaderBazaar: React.FC<VariantProps> = (props) => {
  const hydrated = useHydrated();
  const isMobileMq = useMediaQuery("(max-width:767px)");
  const isMobile = hydrated && isMobileMq;
  const [scrolled, setScrolled] = React.useState(false);

  React.useEffect(() => {
    setScrolled(isMobile ? window.pageYOffset >= 105 : window.pageYOffset >= 145);
    const handler = throttle(
      () => setScrolled(isMobile ? window.pageYOffset >= 105 : window.pageYOffset >= 145),
      25,
    );
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  }, [isMobile]);

  return (
    <>
      <Topbar socialLinks={props.socialItems} notification={props.notification} />

      <Sticky fixedOn={0} onSticky={false} scrollDistance={300}>
        <Header isFixed={scrolled} {...props} searchInput={<SearchInput />} />
      </Sticky>

      <MobileNavigationBar {...props} />
    </>
  );
};

HeaderBazaar.displayName = "HeaderBazaar";

export default HeaderBazaar;
